/* eslint-disable react/jsx-no-useless-fragment */
import { BreadCrumb } from "ui/bread-crumbs";
import { PATHS } from "routes/paths";
import CreateBulkTickets from "components/tickets/bulk/bulk-creation";
import SiteReplenishmentTickets from "components/tickets/bulk/bulk-site-replenishment";
import CloseBulkCashTickets from "components/tickets/bulk/bulk-cash-closing";
import CloseBulkTickets from "components/tickets/bulk/bulk-closing";

export default function BulkOperations() {
  return (
    <>
      <div className="form-container">
        <BreadCrumb
          items={[
            { to: PATHS.openTickets, text: `Tickets` },
            {
              text: `Create Tickets`,
            },
          ]}
        />
        <div className="flex flex-col gap-[16px]">
          <div className="flex flex-row gap-[16px]">
            <div className="w-[50%] flex">
              <CreateBulkTickets />
            </div>
            <div className="w-[50%] flex">
              <CloseBulkTickets />
            </div>
          </div>
          <div className="flex flex-row gap-[16px]">
            <div className="w-[50%] flex">
              <SiteReplenishmentTickets />
            </div>
            <div className="w-[50%] flex">
              <CloseBulkCashTickets />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
